let chatOpen = true;
let unreadCount = 0;
let unreadObservers = [];
let originalTabTitle = typeof document !== "undefined" ? document.title : "";
const TAB_TITLE_PREFIX = "● ";
const TAB_TITLE_SUFFIX = " Nova mensagem";


export function setChatOpen(isOpen) {
  chatOpen = isOpen;
}


export function getUnreadCount() {
  return unreadCount;
}


function incrementUnread() {
  unreadCount += 1;
  unreadObservers.forEach((fn) => fn(unreadCount));
}


export function clearUnread() {
  if (unreadCount > 0) {
    unreadCount = 0;
    unreadObservers.forEach((fn) => fn(0));
    restoreTabTitle();
  }
}


export function subscribeUnreadCount(callback) {
  unreadObservers.push(callback);
  callback(unreadCount);
  return () => {
    unreadObservers = unreadObservers.filter((cb) => cb !== callback);
  };
}


function shouldShowNotification() {
  const isTabHidden = document.hidden;
  const isChatMinimized = !chatOpen;
  return isTabHidden || isChatMinimized;
}


function updateTabTitle() {
  if (typeof document === "undefined") return;

  if (!originalTabTitle && !document.title.startsWith(TAB_TITLE_PREFIX)) {
    originalTabTitle = document.title;
  }
  const count = unreadCount > 0 ? unreadCount : 1;
  document.title = `${TAB_TITLE_PREFIX}(${count})${TAB_TITLE_SUFFIX}`;
}


export function restoreTabTitle() {
  if (typeof document === "undefined") return;
  if (originalTabTitle) {
    document.title = originalTabTitle;
  }
}

function initVisibilityListener() {
  if (typeof document === "undefined") return;
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) {
      if (unreadCount > 0) {
        updateTabTitle();
      } else {
        restoreTabTitle();
      }
    }
  });
}
initVisibilityListener();

export function notifyNewMessage(message) {
  const shouldNotify = shouldShowNotification();
  if (shouldNotify) {
    incrementUnread();
    updateTabTitle();
  }
}